// extracted by mini-css-extract-plugin
export var active = "Header-module--active--6176d";
export var alt = "Header-module--alt--b9afd";
export var brandLogo = "Header-module--brandLogo--cc993";
export var branding = "Header-module--branding--ab22b";
export var container = "Header-module--container--ec9a1";
export var desktopOnly = "Header-module--desktopOnly--82180";
export var elementFocusable = "Header-module--elementFocusable--2c040";
export var elementInvisible = "Header-module--elementInvisible--f9fe3";
export var hamburgerIcon = "Header-module--hamburgerIcon--40b49";
export var header = "Header-module--header--12cad";
export var link = "Header-module--link--ab508";
export var logo = "Header-module--logo--cd429";
export var main = "Header-module--main--2274b";
export var menu = "Header-module--menu--52178";
export var menuContainer = "Header-module--menuContainer--dfbe2";
export var menuWrapper = "Header-module--menuWrapper--797ab";
export var mobilMenu = "Header-module--mobilMenu--910b9";
export var mobileOnly = "Header-module--mobileOnly--817af";
export var open = "Header-module--open--8b708";
export var openMenu = "Header-module--openMenu--dc651";
export var row = "Header-module--row--99d00";
export var secondaryContainer = "Header-module--secondaryContainer--ff5e0";
export var styledRow = "Header-module--styledRow--d6571";
export var textLeft = "Header-module--textLeft--5fec6";
export var visuallyHidden = "Header-module--visuallyHidden--7ec44";